module.exports = __webpack_public_path__ + "media/images/emblems/GW-FR-Botterens_neu-47fe95bf198bb919277a0c5fa46d2e9f.png";